// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".missingFieldsDiv .el-dialog__body{padding:1.25rem}.missingFields{background:rgba(19,181,232,.1);padding:.5rem;list-style-position:inside}.missingFields ::marker{font-size:19px}.missingFields b{position:relative;left:-10px}#reason-zero-arrow .el-icon-arrow-up{color:#333}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
